import styled from 'styled-components'

const ActionsBoxMasterIconUi = styled.i.attrs(() => ({
  className: 'fa-light fa-bolt-lightning',
}))`
  margin-left: 10px;
`

export default ActionsBoxMasterIconUi
